/**
 * The library's theme lifecycle. The <head> script paints the saved theme;
 * this keeps it right once the page has run, as theme-ui does in the main
 * app. The library has no picker, so there is nothing else to update.
 */
import { initTheme, reconcileTheme, setThemeFlagChecker } from '../../../src/client/theme.js';

/** Replace a stale page's random paint before any flag work can persist over it. */
export function startLibraryTheme() {
  initTheme();
}

/**
 * Apply fetched flags, then keep checking on return to the tab.
 * getFeatures() returns {} on failure, which must not read as every theme
 * disabled, so flags are wired only when the server answered.
 */
export function syncLibraryTheme(features) {
  if (Object.keys(features).length > 0) {
    setThemeFlagChecker((name) => features[name] === true);
  }
  reconcileTheme();
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') reconcileTheme();
  });
}
